__webpack_require__.p = "https://cdn-shared.mathletics.com/teacher-modules/assessments-assign/66/";